import React from 'react';
import MeAgendaContainer from '../../../Components/Dashboards/Me/MeAgendaContainer';

export default function MeJW() {
    return (
        <div className='page-body'>
            <MeAgendaContainer defaultTab="JW" />
        </div>
    );
}
